// Таблица соответствия Unicode (UTF-16) в CP1251 для кириллицы и других символов
export function getCp1251Byte(charCode: number): number | null {
    // ASCII символы (0-127) одинаковы в обеих кодировках
    if (charCode < 128) {
        return charCode;
    }

    // Таблица соответствия для кириллицы и специальных символов CP1251
    const utf16ToCp1251: Record<number, number> = {
        // Кириллические заглавные буквы (А-Я): Unicode 1040-1071 -> CP1251 192-223
        1025: 168, // Ё -> 0xA8
        1040: 192, // А -> 0xC0
        1041: 193, // Б -> 0xC1
        1042: 194, // В -> 0xC2
        1043: 195, // Г -> 0xC3
        1044: 196, // Д -> 0xC4
        1045: 197, // Е -> 0xC5
        1046: 198, // Ж -> 0xC6
        1047: 199, // З -> 0xC7
        1048: 200, // И -> 0xC8
        1049: 201, // Й -> 0xC9
        1050: 202, // К -> 0xCA
        1051: 203, // Л -> 0xCB
        1052: 204, // М -> 0xCC
        1053: 205, // Н -> 0xCD
        1054: 206, // О -> 0xCE
        1055: 207, // П -> 0xCF
        1056: 208, // Р -> 0xD0
        1057: 209, // С -> 0xD1
        1058: 210, // Т -> 0xD2
        1059: 211, // У -> 0xD3
        1060: 212, // Ф -> 0xD4
        1061: 213, // Х -> 0xD5
        1062: 214, // Ц -> 0xD6
        1063: 215, // Ч -> 0xD7
        1064: 216, // Ш -> 0xD8
        1065: 217, // Щ -> 0xD9
        1066: 218, // Ъ -> 0xDA
        1067: 219, // Ы -> 0xDB
        1068: 220, // Ь -> 0xDC
        1069: 221, // Э -> 0xDD
        1070: 222, // Ю -> 0xDE
        1071: 223, // Я -> 0xDF

        // Кириллические строчные буквы (а-я): Unicode 1072-1103 -> CP1251 224-255
        1105: 184, // ё -> 0xB8
        1072: 224, // а -> 0xE0
        1073: 225, // б -> 0xE1
        1074: 226, // в -> 0xE2
        1075: 227, // г -> 0xE3
        1076: 228, // д -> 0xE4
        1077: 229, // е -> 0xE5
        1078: 230, // ж -> 0xE6
        1079: 231, // з -> 0xE7
        1080: 232, // и -> 0xE8
        1081: 233, // й -> 0xE9
        1082: 234, // к -> 0xEA
        1083: 235, // л -> 0xEB
        1084: 236, // м -> 0xEC
        1085: 237, // н -> 0xED
        1086: 238, // о -> 0xEE
        1087: 239, // п -> 0xEF
        1088: 240, // р -> 0xF0
        1089: 241, // с -> 0xF1
        1090: 242, // т -> 0xF2
        1091: 243, // у -> 0xF3
        1092: 244, // ф -> 0xF4
        1093: 245, // х -> 0xF5
        1094: 246, // ц -> 0xF6
        1095: 247, // ч -> 0xF7
        1096: 248, // ш -> 0xF8
        1097: 249, // щ -> 0xF9
        1098: 250, // ъ -> 0xFA
        1099: 251, // ы -> 0xFB
        1100: 252, // ь -> 0xFC
        1101: 253, // э -> 0xFD
        1102: 254, // ю -> 0xFE
        1103: 255, // я -> 0xFF

        // Дополнительные символы CP1251 (не ASCII)
        8364: 136, // € -> 0x88
        8222: 132, // „ -> 0x84
        8220: 147, // " -> 0x93
        8221: 148, // " -> 0x94
        8211: 150, // – -> 0x96
        8212: 151, // — -> 0x97
        8482: 153, // ™ -> 0x99
        8230: 133, // … -> 0x85
        8249: 139, // ‹ -> 0x8B
        8250: 155, // › -> 0x9B
    };

    return utf16ToCp1251[charCode] || null;
}
export function cutText(text = "", length = 100) {
    if (1 + text.length > length) {
        return text.substring(0, length) + "…";
    }
    return text;
}
/**
 * первый символ в нижний регистр
 * @param value исходная строка
 * @returns строка с первым символом в нижний регистр
 */
export function getStringWithFirstLetterLowercase(value: string) {
    return value.charAt(0).toLocaleLowerCase() + value.slice(1);
}
